import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { Recuperacao } from '../../shared';

declare var $: any;

@Component({
  selector: 'app-recuperacao-pin',
  templateUrl: './recuperacao-pin.component.html',
  styleUrls: ['./recuperacao-pin.component.css']
})
export class RecuperacaoPinComponent implements OnInit {

    @Input() regex : string = "";
    @Input() descricaoRegex : string = "";
    @Output() enviaMensagemSucesso = new EventEmitter();
    @Output() enviaNovoCodigoChave = new EventEmitter();
    public palavras: Array<string> = new Array<string>(12);
    public palavrasPreenchidas: boolean = false;
    public pinAlterado: boolean = false;
    public pin: string;
    public confirmaPin: string;
    public usuarioId: number;
    public organizacaoId: number;
    public errorMessage: string;
    public disabledSubmit: boolean = false;

    constructor(private usuarioService : UsuarioService) {
    
    }

    ngOnInit() {
        const currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.usuarioId = currentUser.id;
        this.organizacaoId = currentUser.organizacaoId;
    }

    proximaEtapa() {
        for (let palavra of this.palavras) {
            if (!palavra) {
                this.errorMessage = "Todos os campos devem ser preenchidos";
                return;
            }
        }

        this.palavrasPreenchidas = true;
        this.errorMessage = null;
    }

    cancelar(){
        this.errorMessage = null;
        this.fechaJanela();
    }

    fechaJanela() {
        this.palavrasPreenchidas = false;
        this.pinAlterado = false;

        if (!this.errorMessage){
            $('#modalRecuperarPinPalavrasChave').modal('toggle');
        }
    }

    alterarPin() {
        this.disabledSubmit = true;
        let recuperacao: Recuperacao = new Recuperacao();
        recuperacao.palavras = this.palavras;
        recuperacao.novoPin = this.pin;

        this.usuarioService.alterarPinPorPalavraChave(this.usuarioId, this.organizacaoId, recuperacao).subscribe(
            (novaRecuperacao) => {
                this.pinAlterado = true;
                this.enviaNovoCodigoChave.emit(novaRecuperacao.codigoChave);
                this.enviaMensagemSucesso.emit("PIN alterado com sucesso.");
                $('#modalRecuperarPinPalavrasChave').modal('toggle');
            },
            (err) => {
                this.disabledSubmit = false;
                this.limparCampos();
                this.errorMessage = err.message;
                this.fechaJanela();
            }
        );
    }

    limparCampos() {
        this.pin = "";
        this.confirmaPin = "";    
    }

    clickFechar() {
        this.limparCampos();
        this.errorMessage = null;
        this.palavras = new Array<string>(12);
        this.fechaJanela();
    }
}